import { computed } from "@angular/core";
import { signalStoreFeature, withComputed } from "@ngrx/signals";
import { IUserProfileState } from "./user-profile.state";
import { type } from "@ngrx/signals";

export const withUserProfileComputed = signalStoreFeature(
    { state: type<IUserProfileState>() },
    withComputed(({ userProfile }) => ({
        firstName: computed(() => userProfile()?.displayName?.split(' ')[0] ?? ''),
        lastName: computed(() => userProfile()?.displayName?.split(' ')[1] ?? ''),
        initials: computed(() => {
            const firsName = userProfile()?.displayName?.split(' ')[0] ?? '';
            const lastName = userProfile()?.displayName?.split(' ')[1] ?? '';
            return `${firsName.charAt(0) ?? ''}${lastName.charAt(0) ?? ''}`.toUpperCase();
        }),
        fullName: computed(() => userProfile()?.displayName ?? ''),
        roleName: computed(() => userProfile()?.roleName ?? ''),
        emailAddress: computed(() => userProfile()?.emailAddress ?? ''),
        avatar: computed(() => userProfile()?.avatar ?? ''),
        userName: computed(() => userProfile()?.userName ?? ''),
        userProfileGuid: computed(() => userProfile()?.userProfileGuid ?? ''),
        userRoles: computed(() => userProfile()?.userRoles ?? []),
        personGuid: computed(() => userProfile()?.personGuid ?? ''),
        isActive: computed(() => userProfile()?.isActive ?? false),
        isEmailVerified: computed(() => userProfile()?.isEmailVerified ?? false),
        hasProfile: computed(() => userProfile() !== null),
        profileRole: computed(() => {
            const profile = userProfile();
            if (!profile) return null;
            return {
                userRoleId: profile.userRoleId,
                roleId: profile.roleId,
                roleName: profile.roleName,
                userRoles: profile.userRoles ?? [],
            };
        }),
    }))
);
